import React from 'react';

export const RefusPrecedentModal = ({ isOpen, onClose, data }) => {
  if (!isOpen || !data) return null;
  const { nom, prenom, colonnes = [], resultats = [] } = data;

  const renderCell = (val, type) => {
    if (type === 'flag') return val ? 'Oui' : '';
    return (val === null || val === undefined || val === '') ? '—' : val;
  };

  return (
    <div className="modal-overlay" data-testid="refus-precedent-modal">
      <div className="modal-content" style={{ width: '95vw', maxWidth: 1500, maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #808080', paddingBottom: 6, marginBottom: 8 }}>
          <h3 style={{ margin: 0, fontSize: 15 }} data-testid="refus-precedent-title">
            Refus précédent — {prenom} {nom} ({resultats.length})
          </h3>
          <button className="win-btn" onClick={onClose} data-testid="btn-close-refus-precedent" style={{ padding: '2px 10px' }}>×</button>
        </div>

        <div style={{ overflow: 'auto', flex: 1 }}>
          <table className="win-table" data-testid="refus-precedent-grid" style={{ borderCollapse: 'collapse', whiteSpace: 'nowrap' }}>
            <thead>
              <tr>
                {colonnes.map((c, i) => (
                  <th key={i} style={{ whiteSpace: 'nowrap', fontSize: 11, textAlign: c.type === 'flag' ? 'center' : 'left' }}>
                    {c.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {resultats.map((ligne, ri) => (
                <tr key={ri} data-testid={`refus-precedent-row-${ri}`}>
                  {ligne.map((val, ci) => {
                    const type = colonnes[ci] ? colonnes[ci].type : 'text';
                    return (
                      <td key={ci} style={{ fontSize: 11, textAlign: type === 'flag' ? 'center' : 'left', fontWeight: type === 'flag' && val ? 600 : 400 }}>
                        {renderCell(val, type)}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ textAlign: 'right', marginTop: 10 }}>
          <button className="win-btn" onClick={onClose} data-testid="btn-continuer-refus-precedent">Continuer</button>
        </div>
      </div>
    </div>
  );
};

export default RefusPrecedentModal;
